import React from "react";
import "../nav/Navigation.css";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import {faBed, faClock, faCoins, faCamera} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {User} from "../types/Types";
import AuthCheck from "../auth/AuthCheck";

interface Props {
    currentUser: User | undefined;
}

function LeaderboardNav(props: Props) {
    return (
        <Container>
            <AuthCheck />
            <Nav variant="tabs" className="mb-2 mr-auto sub-menu-nav">
                <>
                    <NavLink className="nav-link" to="/leaderboard/visits">
                        Visits
                    </NavLink>
                    {props.currentUser && !props.currentUser.socialDisabled && <NavLink className="nav-link" to="/leaderboard/verified">
                        Verified
                    </NavLink>}
                    {props.currentUser && !props.currentUser.socialDisabled &&<NavLink className="nav-link" to="/leaderboard/sessions">
                        <FontAwesomeIcon icon={faClock}/>
                    </NavLink>}
                    {props.currentUser && !props.currentUser.socialDisabled && <NavLink className="nav-link" to="/leaderboard/photos">
                        <FontAwesomeIcon icon={faCamera}/>
                    </NavLink>}
                    {props.currentUser && !props.currentUser.socialDisabled && <NavLink className="nav-link" to="/leaderboard/stays">
                        <FontAwesomeIcon icon={faBed}/>
                    </NavLink>}
                    {props.currentUser && !props.currentUser.socialDisabled && <NavLink className="nav-link" to="/leaderboard/year">
                        <FontAwesomeIcon className={"mr-1"} icon={faCoins}/> Points
                    </NavLink>}
                </>
            </Nav>
        </Container>
    )
}

export default LeaderboardNav;
